// Stack Auth Configuration
import { StackClientApp } from "@stackframe/react";
import { useNavigate } from "react-router-dom";

export const stackClient = new StackClientApp({
  projectId: "58dd3f39-e3f1-4510-b6c0-abe0be764ed5",
  publishableClientKey: "pck_38yabjrp5t23f556s6mswtrb9bjb79yz6xamwkw28djpr",
  tokenStore: "cookie",
  urls: {
    home: "/",
    afterSignIn: "/user-dashboard",
    afterSignUp: "/user-dashboard",
    signIn: "/handler/signin",
  }
});
